import React from 'react';

const FrameworkChipBar = ({ frameworks, selectedFrameworks, onFrameworkChange }) => {
  const handleChipClick = (frameworkCode) => {
    if (selectedFrameworks.includes(frameworkCode)) {
      onFrameworkChange(selectedFrameworks.filter(f => f !== frameworkCode));
    } else {
      onFrameworkChange([...selectedFrameworks, frameworkCode]);
    }
  };

  const handleSelectAll = () => {
    onFrameworkChange([]);
  };

  if (!frameworks || frameworks.length === 0) {
    return null;
  }

  return (
    <div className="framework-chip-bar-ultra">
      {frameworks.map(fw => (
        <button
          key={fw.code}
          className={`framework-chip-ultra ${selectedFrameworks.includes(fw.code) ? 'active' : ''}`}
          onClick={() => handleChipClick(fw.code)}
        >
          {selectedFrameworks.includes(fw.code) && (
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{marginRight: '4px'}}>
              <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
          {fw.code}
        </button>
      ))}
      <button
        className={`framework-chip-ultra all ${selectedFrameworks.length === 0 ? 'active' : ''}`}
        onClick={handleSelectAll}
      >
        All Frameworks
      </button>
    </div>
  );
};

export default FrameworkChipBar;
